var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Prop, Watch } from "vue-facing-decorator";
import { ContactGroupClient, PersonsClient, GetContactGroupListPaginatedQuery, GetPersonListQuery, PaginatedEnumerableOfContactGroupModel, ContactGroupModel, CreateContactGroupCommand, UpdateContactGroupCommand, SortDescription, SortDirection } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import Sorter from "@/common/utils/sorter";
import { HttpHelper } from "@/app/utils/http-helper";
import { useForm } from 'vee-validate';
import * as yup from 'yup';
const contactGroupsClient = new ContactGroupClient(window.apiUrl);
const personsClient = new PersonsClient(window.apiUrl);
let CompanyGroupContactsVue = class CompanyGroupContactsVue extends Vue {
    constructor() {
        super(...arguments);
        // simpletons
        this.working = false;
        this.editingContactGroup = false;
        this.searchAttempted = false;
        this.contacts = [];
        this.contactsFilter = "";
        this.showOnlySelected = false;
        this.loadingContacts = false;
        // components
        this.sorter = new Sorter(new SortDescription({
            fieldName: "Description",
            direction: SortDirection.Ascending
        }));
        // models
        this.contactGroup = new ContactGroupModel();
        this.query = new GetContactGroupListPaginatedQuery({
            pageNo: 1,
            pageSize: 100,
            includeDeleted: false,
            companyId: this.companyId,
            sort: this.sorter.currentSort
        });
        this.data = new PaginatedEnumerableOfContactGroupModel();
    }
    created() {
        this.search();
    }
    ;
    getContacts() {
        this.loadingContacts = true;
        personsClient
            .getListPOST(new GetPersonListQuery({ companyId: this.companyId, includeDeleted: false, keywords: "" }))
            .then(response => {
            this.contacts = response;
        })
            .finally(() => {
            this.loadingContacts = false;
        });
    }
    // get
    search() {
        if (!this.canSearch)
            return;
        if (this.working)
            return;
        if (!this.query)
            return;
        this.working = true;
        contactGroupsClient
            .getListPaginated(this.query)
            .then(response => {
            this.data = new PaginatedEnumerableOfContactGroupModel();
            if (!response)
                return;
            this.data = response;
            this.query.pageNo = this.data.displayedPage;
            this.query.pageSize = this.data.pageSize;
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.searchAttempted = true;
        });
    }
    ;
    onSortChanged() {
        this.query.sort = this.sorter.currentSort;
        this.search();
    }
    ;
    // set
    add() {
        this.getContacts();
        this.contactGroup = new ContactGroupModel();
        this.contactGroup.persons = [];
        this.contactGroup.companyId = this.query.companyId || 0;
        this.resetForm();
        this.editingContactGroup = true;
    }
    ;
    edit(contactGroup) {
        this.getContacts();
        this.contactGroup = new ContactGroupModel(contactGroup);
        this.editingContactGroup = true;
        this.setValues({
            description: this.contactGroup.description
        });
    }
    ;
    save(contactGroup) {
        if (this.working)
            return;
        const handleSubmitAction = this.handleSubmit(() => {
            this.working = true;
            let promise = () => {
                return !contactGroup.contactGroupId
                    ? contactGroupsClient.add(new CreateContactGroupCommand({ requestModel: contactGroup }))
                    : contactGroupsClient.update(contactGroup.contactGroupId, new UpdateContactGroupCommand({ requestModel: contactGroup }));
            };
            promise().then(response => {
                Notifier.onOk();
                contactGroup.contactGroupId = response;
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
                this.search();
            });
        }, () => {
            Notifier.onError("Please check that you have correctly entered all contacts fields.");
        });
        handleSubmitAction();
    }
    ;
    archive(contactGroup) {
        if (this.working)
            return;
        this.$confirmModal.show("Are you sure that you want to archive this contact group?", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            this.working = true;
            contactGroupsClient
                .delete(contactGroup.contactGroupId)
                .then(() => {
                contactGroup.whenDeleted = new Date();
                var contactGroupInTheList = this.data.records.find(item => item.contactGroupId == contactGroup.contactGroupId);
                if (contactGroupInTheList) {
                    contactGroupInTheList.whenDeleted = new Date();
                }
                Notifier.onOk();
            })
                .catch((ex) => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
    }
    ;
    restore(contactGroup) {
        if (this.working)
            return;
        this.working = true;
        contactGroupsClient
            .restore(contactGroup.contactGroupId)
            .then(() => {
            contactGroup.whenDeleted = undefined;
            var contactGroupInTheList = this.data.records.find(item => item.contactGroupId == contactGroup.contactGroupId);
            if (contactGroupInTheList) {
                contactGroupInTheList.whenDeleted = undefined;
            }
            Notifier.onOk();
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    cancel() {
        this.resetForm();
        this.contactGroup = new ContactGroupModel();
        this.editingContactGroup = false;
    }
    ;
    getContactsNamesTitle(item) {
        if (item.persons) {
            return item.persons
                .map(person => person.firstName + ' ' + person.lastName)
                .sort((a, b) => {
                if (a < b)
                    return -1;
                if (a > b)
                    return 1;
                return 0;
            })
                .join("\r\n");
        }
        return "";
    }
    getContactsNames(item) {
        if (item.persons) {
            return item.persons
                .map(person => person.firstName + ' ' + person.lastName)
                .sort((a, b) => {
                if (a < b)
                    return -1;
                if (a > b)
                    return 1;
                return 0;
            })
                .join(", ");
        }
        return "";
    }
    // computed
    get canSearch() {
        return this.companyId ? true : false;
    }
    ;
    get noData() {
        return this.searchAttempted && (!this.data || !this.data.records || !this.data.records.length);
    }
    ;
    get contactsFiltered() {
        var strFilter = this.contactsFilter.toLowerCase();
        return this.contacts
            .filter(item => { var _a, _b, _c; return (((_a = item.firstName) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(strFilter)) || ((_b = item.lastName) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(strFilter)) || ((_c = item.emailAddress) === null || _c === void 0 ? void 0 : _c.toLowerCase().includes(strFilter))); })
            .filter(item => !this.showOnlySelected || this.isContactSelected(item));
    }
    isContactSelected(item) {
        try {
            return this.contactGroup.persons != null && this.contactGroup.persons.map(item => item.personId).includes(item.personId);
        }
        catch (ex) {
            console.error(ex);
        }
        return false;
    }
    selectContact(item) {
        console.log('select', this.contactGroup.persons);
        if (!this.contactGroup.persons)
            return;
        console.log('select item', item);
        var person = this.contactGroup.persons.find(person => person.personId == item.personId);
        console.log('select person', person);
        if (person)
            this.contactGroup.persons = this.contactGroup.persons.filter(person => person.personId != item.personId);
        else
            this.contactGroup.persons.push(item);
    }
    selectedContactCount() {
        var _a, _b, _c, _d, _e, _f;
        var count = (_c = (_b = (_a = this.contactGroup) === null || _a === void 0 ? void 0 : _a.persons) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0;
        this.showOnlySelected = count == 0 ? false : this.showOnlySelected;
        return (_f = (_e = (_d = this.contactGroup) === null || _d === void 0 ? void 0 : _d.persons) === null || _e === void 0 ? void 0 : _e.length) !== null && _f !== void 0 ? _f : 0;
    }
};
__decorate([
    Prop(),
    __metadata("design:type", Number)
], CompanyGroupContactsVue.prototype, "companyId", void 0);
__decorate([
    Watch("query.pageNo"),
    Watch("query.includeDeleted"),
    Watch("query.companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CompanyGroupContactsVue.prototype, "search", null);
__decorate([
    Watch("sorter.currentSort"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CompanyGroupContactsVue.prototype, "onSortChanged", null);
CompanyGroupContactsVue = __decorate([
    Component({
        name: "CompanyGroupContactsVue",
        setup() {
            const { errors, handleSubmit, defineInputBinds, setValues, resetForm } = useForm({
                validationSchema: yup.object({
                    description: yup.string().trim().required(),
                }),
            });
            const descriptionVal = defineInputBinds('description');
            return {
                errors,
                handleSubmit,
                setValues,
                resetForm,
                descriptionVal
            };
        }
    })
], CompanyGroupContactsVue);
export default CompanyGroupContactsVue;
